<template>
  <div>
    <el-dialog
      title="更换客服人员"
      :visible.sync="dialogFormVisible"
      width="500px"
      @close="close"
      v-dialogDrag
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="110px"
      >
        <el-form-item label="请选择客服" prop="email">
          <el-select
            v-model="dataObj.userId"
            clearable
            filterable
            placeholder="请选择"
            class="input-width-two"
          >
            <el-option
              v-for="(val, key, i) in dropList.amazonCustomerList"
              :label="val"
              :value="key"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible = false"
          v-preventReClick="5000"
          :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkEdit('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 更换客服人员弹窗组件（Amazon 版）
 * 功能：从 amazonCustomerList 下拉选择新客服，调用 editAmazonCustomer 接口保存（ids 由父组件批量传入）
 */
import { editAmazonCustomer } from "@/api/user";
export default {
  name: "edit",
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 表单校验规则（当前为空，实际无校验）
      rules: {},
      // 更换客服提交数据：新客服 userId 与待更换的邮件 id 集合 ids
      dataObj: {
        userId: "",
        ids: "",
      },
      // 按钮禁用状态（防止重复提交）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
    };
  },
  created() {
    // 组件创建时拉取客服下拉数据并回显 scope
    this.handleClick();
  },
  computed: {
    dropList: {
      get() {
        return this.$store.getters.dropList;
      },
    },
  },
  methods: {
    /** 拉取客服下拉数据并回显父组件传入的 scope */
    handleClick() {
      this.$store.dispatch("getDropListTwo", ["amazonCustomerList"]);
      Object.assign(this.dataObj, this.scope);
    },
    /** 关闭弹窗并通知父组件 */
    close() {
      this.$emit("isShowEdit");
    },
    /**
     * 校验并提交更换客服
     * @param {String} formName 表单 ref 名称
     */
    checkEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editAmazonCustomer(this.dataObj).then((result) => {
            if (result.code == 200) {
              this.$message({
                message: result.msg,
                type: "success",
              });
              this.$emit("getList");
              this.$emit("isShowEdit");
            }
          });
        }
      });
    },
  },
};
</script>